import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'BlogPage',
})(({ brandColors }) => ({
  gridItem: {
    width: '100%',
  },
  blog: {
    background: brandColors.tintsOffWhite60,
  },
  blogRichTextWrapper: {
    minWidth: 0,
  },
}));

export default useStyles;
